import React from 'react';

const TextField = ({
  input,
  label,
  placeholder,
  type,
  addonLeft,
  addonRight,
  infoButton,
  maxLength,
  smFieldSize,
  labelSize,
  readOnly,
  meta: { touched, error },
}) => {
  const textArea = () => (
    <textarea
      maxLength={maxLength}
      className="form-control textarea"
      {...input}
      placeholder={placeholder || ''}
      disabled={readOnly}
    />
  );

  return label ? (
    <div className={touched && error ? 'form-group has-error' : 'form-group'}>
      {label && (
        <div className={labelSize ? `col-sm-${labelSize}` : 'col-sm-12'}>
          <label className="control-label">{label}</label> {infoButton}
        </div>
      )}

      <div>
        {type === 'textarea' ? (
          <div className={smFieldSize ? `col-sm-${smFieldSize}` : ''}>
            <textarea
              maxLength={maxLength}
              className="form-control textarea"
              {...input}
              placeholder={placeholder || ''}
              disabled={readOnly}
            />
          </div>
        ) : addonLeft || addonRight ? (
          <div className="input-group">
            {addonLeft && <div className="input-group-addon">{addonLeft}</div>}
            <input
              className="form-control"
              {...input}
              placeholder={placeholder || ''}
              type={type}
              disabled={readOnly}
            />
            {addonRight && <div className="input-group-addon">{addonRight}</div>}
          </div>
        ) : (
          <input
            className="form-control"
            {...input}
            placeholder={placeholder || ''}
            type={type}
            disabled={readOnly}
          />
        )}

        {touched && error && <span className="input-error">{error}</span>}
      </div>
    </div>
  ) : (
    <div>
      {textArea()}
      {touched && error && <span className="input-error">{error}</span>}
    </div>
  );
};

export default TextField;
